import { render, staticRenderFns } from "./06-CompositeExtremeEventRecognition.md?vue&type=template&id=0c3380f4&"
import script from "./06-CompositeExtremeEventRecognition.md?vue&type=script&lang=js&"
export * from "./06-CompositeExtremeEventRecognition.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports